import React, { useState, useEffect } from 'react';

// --- Custom SVG Icons ---
// These icons use currentColor so they will inherit text color from Tailwind classes
const BrainCircuitIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-brain-circuit">
    <path d="M12 2a2 2 0 0 0-2 2v3.1a2 2 0 0 0 1.139 1.76l.33.195a2 2 0 0 0 1.722 0l.33-.195A2 2 0 0 0 14 7.1V4a2 2 0 0 0-2-2z"/><path d="M16 20h2a2 2 0 0 0 2-2v-1.1a2 2 0 0 0-1.139-1.76l-.33-.195a2 2 0 0 0-1.722 0l-.33.195A2 2 0 0 0 16 16.9V18a2 2 0 0 0 2 2z"/><path d="M8 20h2a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2z"/><path d="M4 18h2a2 2 0 0 0 2-2v-1.1a2 2 0 0 0-1.139-1.76l-.33-.195a2 2 0 0 0-1.722 0l-.33.195A2 2 0 0 0 4 15.9V18a2 2 0 0 0 2 2z"/><path d="M20 18h2a2 2 0 0 0 2-2v-1.1a2 2 0 0 0-1.139-1.76l-.33-.195a2 2 0 0 0-1.722 0l-.33.195A2 2 0 0 0 20 15.9V18a2 2 0 0 0 2 2z"/><path d="M12 22v-1a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2z"/><path d="M2 12h1.1a2 2 0 0 0 1.76-1.139l.195-.33A2 2 0 0 0 5.1 9.722L4.76 9.39A2 2 0 0 0 4 8.2V6a2 2 0 0 0-2-2z"/><path d="M22 12h-1.1a2 2 0 0 0-1.76-1.139l-.195-.33A2 2 0 0 0 18.9 9.722L19.24 9.39A2 2 0 0 0 20 8.2V6a2 2 0 0 0-2-2z"/><path d="M12 2V1a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2z"/><path d="M12 22v1a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2z"/><path d="M2 12H1a2 2 0 0 0-2-2v-2a2 2 0 0 0 2-2h1a2 2 0 0 0 2 2v2a2 2 0 0 0-2 2z"/><path d="M22 12h1a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2z"/><path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"/><path d="M12 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"/>
  </svg>
);

const CodeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-code">
    <polyline points="16 18 22 12 16 6"/>
    <polyline points="8 6 2 12 8 18"/>
  </svg>
);

const CheckCircleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check-circle">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
      <polyline points="22 4 12 14.01 9 11.01"/>
  </svg>
);

const PaletteIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-palette">
      <circle cx="13.5" cy="6.5" r=".5" fill="currentColor"/>
      <circle cx="17.5" cy="10.5" r=".5" fill="currentColor"/>
      <circle cx="8.5" cy="7.5" r=".5" fill="currentColor"/>
      <circle cx="10.5" cy="14.5" r=".5" fill="currentColor"/>
      <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.83 0 1.64-.13 2.4-.35 2.72-1.04 4.88-3.23 5.9-5.9.96-2.42 1.4-4.8 1.4-7.05C22 6.5 17.5 2 12 2z"/>
      <path d="M5 12c0-2.2 1.5-4 4-4s4 2 4 4c0 1.2-.6 2.3-1.5 3L12 17h1.5a4 4 0 0 0 4-4 2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2z"/>
  </svg>
);

const BookOpenIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-book-open">
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 =0 3-3H2z"/>
      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h6z"/>
  </svg>
);

const CloudIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-cloud">
    <path d="M17.5 19H18a2 2 0 0 0 2-2.5V16a2 2 0 0 0-2-2h-.5"/>
    <path d="M11 19H9a7 7 0 1 1 4.2-12.3 3.45 3.45 0 0 1 5.5 4v.4A2.5 2.5 0 0 1 17.5 19Z"/>
  </svg>
);

const MailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-mail">
    <rect width="20" height="16" x="2" y="4" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
);

const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-phone">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2.02 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

const MapPinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-map-pin">
    <path d="M12 18.3a.9.9 0 0 0 .2.3c.7.7 1.6 1.1 2.5 1.4a2 2 0 =0 2.8 0c.9-.3 1.8-.7 2.5-1.4a.9.9 0 0 0 .2-.3c.4-.5.7-1.1.9-1.7.3-.6.4-1.3.4-2.1V5c0-1.7-1.3-3-3-3H7c-1.7 0-3 1.3-3 3v12.2c0 .8.1 1.5.4 2.1.2.6.5 1.2.9 1.7a.9.9 0 =0 2.8 0c.9-.3 1.8-.7 2.5-1.4a.9.9 0 0 0 .2-.3c.4-.5.7-1.1.9-1.7.3-.6.4-1.3.4-2.1Z"/>
    <circle cx="12" cy="11" r="3"/>
  </svg>
);


const LinkedinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-linkedin">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
    <rect width="4" height="12" x="2" y="9"/>
    <circle cx="4" cy="4" r="2"/>
  </svg>
);

// Custom Hamburger Menu Icon
const MenuIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="4" x2="20" y1="12" y2="12" />
    <line x1="4" x2="20" y1="6" y2="6" />
    <line x1="4" x2="20" y1="18" y2="18" />
  </svg>
);

// Custom Close Icon (X)
const XIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);


// --- Main App Component ---
export default function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State for mobile menu

  // Function to toggle the mobile menu visibility
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Effect to update the current year in the footer
  useEffect(() => {
    const yearSpan = document.getElementById('currentYear');
    if (yearSpan) {
      yearSpan.textContent = new Date().getFullYear();
    }

    // Function to handle scroll and update scroll position
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Function to handle page navigation
  const handlePageChange = (page) => {
    setCurrentPage(page);
    setIsMenuOpen(false); // Close mobile menu on page change
    // Scroll to top when changing page
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // --- Components ---

  // Header component for navigation
  const Header = ({ currentPage, scrollPosition, isMenuOpen, toggleMenu }) => {
    // Determine header classes based on current page and scroll position
    const isHomePageAndTop = currentPage === 'home' && scrollPosition < 100; // Adjust 100px as needed
    const headerBgClass = isHomePageAndTop ? 'bg-transparent' : 'bg-white';
    const headerShadowClass = isHomePageAndTop ? '' : 'shadow-lg';
    const blendModeClass = isHomePageAndTop ? 'blend-difference' : '';
    const headerPositionClass = isHomePageAndTop ? 'absolute' : 'sticky';

    return (
      <header className={`py-4 ${headerPositionClass} top-0 left-0 right-0 z-50 transition-all duration-300 ${headerBgClass} ${headerShadowClass} ${isHomePageAndTop ? '' : 'rounded-b-lg mx-2 mt-2'}`}>
        <div className="container mx-auto px-4 flex justify-between items-center flex-wrap">
          {/* Wrap logo and nav for blend mode */}
          <div className={`${blendModeClass} w-full flex justify-between items-center`}> {/* Removed flex-wrap from here as it's not needed for the main header row */}
            {/* Logo/Company Name */}
            <div className="logo flex items-center rounded-lg p-2 transition-transform transform hover:scale-105">
                {/* Logo image with increased size (h-12) and rounded corners (rounded-xl) */}
                <img src="E__1_-removebg-preview.png" alt="ENIGMALOGIX Logo" className="h-12 w-auto mr-3 rounded-xl" />
                <button onClick={() => handlePageChange('home')} className={`text-3xl font-extrabold focus:outline-none font-poppins ${isHomePageAndTop ? 'text-white' : 'text-blue-950'}`}>
                  ENIGMALOGIX
                </button>
            </div>

            {/* Hamburger Icon for Mobile */}
            <div className="md:hidden">
              <button
                onClick={toggleMenu}
                className={`text-gray-600 hover:text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-lg p-2 transition-all duration-300 ease-in-out ${isHomePageAndTop ? 'text-white' : 'text-blue-950'}`}
                aria-label="Toggle navigation menu"
              >
                {isMenuOpen ? <XIcon size={28} /> : <MenuIcon size={28} />}
              </button>
            </div>

            {/* Desktop Navigation Links */}
            <nav className="hidden md:block"> {/* Use md:block to show on desktop */}
              <ul className="flex justify-end space-x-6 md:space-x-10 text-lg">
                <li>
                  <button
                    onClick={() => handlePageChange('home')}
                    className={`font-medium rounded-md px-3 py-2 ${isHomePageAndTop ? 'text-white' : 'text-blue-950'} hover:text-blue-600 transition-colors ${currentPage === 'home' ? 'border-b-2 border-blue-600' : ''}`}
                  >
                    Home
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => handlePageChange('about')}
                    className={`font-medium rounded-md px-3 py-2 ${isHomePageAndTop ? 'text-white' : 'text-blue-950'} hover:text-blue-600 transition-colors ${currentPage === 'about' ? 'border-b-2 border-blue-600' : ''}`}
                  >
                    About Us
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => handlePageChange('services')}
                    className={`font-medium rounded-md px-3 py-2 ${isHomePageAndTop ? 'text-white' : 'text-blue-950'} hover:text-blue-600 transition-colors ${currentPage === 'services' ? 'border-b-2 border-blue-600' : ''}`}
                  >
                    Services
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => window.open('https://accounts.zoho.in', '_blank', 'noopener noreferrer')}
                    className={`font-medium rounded-md px-3 py-2 ${isHomePageAndTop ? 'text-white' : 'text-blue-950'} hover:text-blue-600 transition-colors`}
                  >
                    Employee
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => handlePageChange('contact')}
                    className="bg-blue-600 text-white px-5 py-2 rounded-full hover:bg-blue-700 transition-colors shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                  >
                    Contact Us
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        {/* Mobile Menu Overlay */}
        {isMenuOpen && (
          <div className="md:hidden fixed inset-0 bg-white bg-opacity-95 z-50 flex flex-col items-center justify-center space-y-8 animate-fade-in">
            <button
              onClick={toggleMenu}
              className="absolute top-6 right-6 text-gray-600 hover:text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-lg p-2 transition-all duration-300 ease-in-out"
              aria-label="Close navigation menu"
            >
              <XIcon size={32} />
            </button>
            <button onClick={() => handlePageChange('home')} className="text-gray-800 text-3xl font-bold hover:text-blue-600 transition-colors duration-200 rounded-lg p-3">
              Home
            </button>
            <button onClick={() => handlePageChange('about')} className="text-gray-800 text-3xl font-bold hover:text-blue-600 transition-colors duration-200 rounded-lg p-3">
              About Us
            </button>
            <button onClick={() => handlePageChange('services')} className="text-gray-800 text-3xl font-bold hover:text-blue-600 transition-colors duration-200 rounded-lg p-3">
              Services
            </button>
            <button onClick={() => window.open('https://accounts.zoho.in', '_blank', 'noopener noreferrer')} className="text-gray-800 text-3xl font-bold hover:text-blue-600 transition-colors duration-200 rounded-lg p-3">
              Employee
            </button>
            <button onClick={() => handlePageChange('contact')} className="text-gray-800 text-3xl font-bold hover:text-blue-600 transition-colors duration-200 rounded-lg p-3">
              Contact Us
            </button>
          </div>
        )}
      </header>
    );
  };

  // Hero Section component
  const HeroSection = () => (
    <section
      className="relative bg-cover bg-center text-white py-24 md:py-32 rounded-lg m-2 shadow-xl pt-24"
      style={{
        backgroundImage: `url('https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg')`,
        backgroundAttachment: 'fixed', // Adds a parallax effect
      }}
    >
      {/* Added a subtle black gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent rounded-lg"></div>
      <div className="container mx-auto px-4 text-center relative z-10">
        {/* Updated Headline */}
        <h1 className="text-4xl md:text-6xl font-extrabold leading-tight mb-6">
          Innovative IT Solutions, Unmatched Expertise
        </h1>
        {/* Updated Sub-headline and Body, with sub-headline now bold and slightly larger */}
        <p className="text-lg md:text-xl mb-10 max-w-3xl mx-auto opacity-90">
          <span className="font-bold text-xl md:text-2xl">Your Trusted Partner in Digital Transformation</span><br/>Empowering businesses with cutting-edge AI, Data, Cloud, and Custom Software Solutions to accelerate growth and achieve digital excellence.
        </p>
        <button
          onClick={() => handlePageChange('services')}
          className="bg-white text-blue-800 px-8 py-3 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 shadow-xl focus:outline-none focus:ring-4 focus:ring-white focus:ring-opacity-50"
        >
          Explore Our Services
        </button>
      </div>
    </section>
  );

  // Services Section component
  const ServicesSection = () => (
    <section className="py-20 bg-gray-50 rounded-lg m-2 shadow-lg">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-blue-950 mb-16">
          Our Services
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Service Card 1: Product Development */}
          <div className="bg-white p-8 rounded-xl shadow-md border border-gray-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="text-blue-600 mb-4 inline-block p-3 bg-blue-100 rounded-full">
              <BrainCircuitIcon className="w-8 h-8" />
            </div>
            <h3 className="text-2xl font-semibold text-blue-800 mb-4">Product Development</h3>
            <p className="text-gray-600 mb-6">
              From ideation to launch, we bring your product vision to life. Our end-to-end development process ensures scalable, user-centric, and market-ready solutions.
            </p>
            <button
              onClick={() => setCurrentPage('contact')}
              className="text-blue-600 font-semibold hover:text-blue-800 flex items-center group"
            >
              Learn More
              <svg className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>
            </button>
          </div>

          {/* Service Card 2: Application and Web Development */}
          <div className="bg-white p-8 rounded-xl shadow-md border border-gray-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="text-blue-600 mb-4 inline-block p-3 bg-blue-100 rounded-full">
              <CodeIcon className="w-8 h-8" />
            </div>
            <h3 className="text-2xl font-semibold text-blue-800 mb-4">Application & Web Development</h3>
            <p className="text-gray-600 mb-6">
              Crafting robust, scalable, and intuitive web and mobile applications tailored to your specific business requirements and user experience goals.
            </p>
            <button
              onClick={() => setCurrentPage('contact')}
              className="text-blue-600 font-semibold hover:text-blue-800 flex items-center group"
            >
              Learn More
              <svg className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>
            </button>
          </div>

          {/* Service Card 3: Quality Analysis */}
          <div className="bg-white p-8 rounded-xl shadow-md border border-gray-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="text-blue-600 mb-4 inline-block p-3 bg-blue-100 rounded-full">
              <CheckCircleIcon className="w-8 h-8" />
            </div>
            <h3 className="text-2xl font-semibold text-blue-800 mb-4">Quality Analysis & Testing</h3>
            <p className="text-gray-600 mb-6">
              Ensuring flawless software performance, security, and reliability through comprehensive quality assurance and rigorous testing methodologies.
            </p>
            <button
              onClick={() => setCurrentPage('contact')}
              className="text-blue-600 font-semibold hover:text-blue-800 flex items-center group"
            >
              Learn More
              <svg className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>
            </button>
          </div>

          {/* Service Card 4: Graphic Design */}
          <div className="bg-white p-8 rounded-xl shadow-md border border-gray-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="text-blue-600 mb-4 inline-block p-3 bg-blue-100 rounded-full">
              <PaletteIcon className="w-8 h-8" />
            </div>
            <h3 className="text-2xl font-semibold text-blue-800 mb-4">Graphic Design</h3>
            <p className="text-gray-600 mb-6">
              Creating visually stunning and impactful designs that captivate your audience, from branding and marketing materials to user interfaces.
            </p>
            <button
              onClick={() => setCurrentPage('contact')}
              className="text-blue-600 font-semibold hover:text-blue-800 flex items-center group"
            >
              Learn More
              <svg className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>
            </button>
          </div>

          {/* Service Card 5: Trainings */}
          <div className="bg-white p-8 rounded-xl shadow-md border border-gray-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="text-blue-600 mb-4 inline-block p-3 bg-blue-100 rounded-full">
              <BookOpenIcon className="w-8 h-8" />
            </div>
            <h3 className="text-2xl font-semibold text-blue-800 mb-4">Professional Trainings</h3>
            <p className="text-gray-600 mb-6">
              Empowering your team with comprehensive training programs in the latest technologies, ensuring they stay ahead in the rapidly evolving digital landscape.
            </p>
            <button
              onClick={() => setCurrentPage('contact')}
              className="text-blue-600 font-semibold hover:text-blue-800 flex items-center group"
            >
              Learn More
              <svg className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>
            </button>
          </div>

          {/* Service Card 6: IT Consultancy */}
          <div className="bg-white p-8 rounded-xl shadow-md border border-gray-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
            <div className="text-blue-600 mb-4 inline-block p-3 bg-blue-100 rounded-full">
              <CloudIcon className="w-8 h-8" /> {/* Reusing cloud icon as a general 'strategic' or 'cloud-based' advice */}
            </div>
            <h3 className="text-2xl font-semibold text-blue-800 mb-4">IT Consultancy</h3>
            <p className="text-gray-600 mb-6">
              Providing expert strategic guidance and innovative solutions to optimize your IT infrastructure, enhance cybersecurity, and drive digital transformation
            </p>
            <button
              onClick={() => setCurrentPage('contact')}
              className="text-blue-600 font-semibold hover:text-blue-800 flex items-center group"
            >
              Learn More
              <svg className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );

  // About Us Section component
  const AboutSection = () => (
    <section className="py-20 bg-gray-50 text-blue-950 rounded-lg m-2 shadow-lg">
      <div className="container mx-auto px-4">
        {/* Changed font to Circular Std Bold */}
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 font-circular-std-bold">
          About Enigmalogix
        </h2>
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="lg:w-1/2">
            {/* Make sure 'image.jpg' is in your /public folder */}
            <img
              src="image.jpg"
              alt="ENIGMALOGIX Team"
              className="rounded-xl shadow-xl w-full h-auto object-cover transform transition-transform duration-500 hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2 text-left">
            <p className="text-lg leading-relaxed mb-6 text-gray-700 font-open-sans-italic"> {/* Added font-open-sans-italic */}
              At Enigmalogix, we are technology partners committed to delivering smart, scalable, and tailored IT
              solutions. Specializing in <span className="font-bold">OpenEdge and Progress technologies</span>, we empower businesses with end-to-end
              services that span <span className="font-bold">product development, web and application development, quality analysis, graphic
              design, IT consulting, and professional training</span>.
            </p>
            <p className="text-lg leading-relaxed mb-6 text-gray-700 font-open-sans-italic"> {/* Added font-open-sans-italic */}
              Our cross-functional team of developers, analysts, designers, and consultants works closely with clients to
              build custom solutions that align with their vision, streamline operations, and drive growth.
            </p>
            <ul className="pl-5 space-y-2 text-lg mb-6 text-gray-700 font-open-sans-italic"> {/* Added font-open-sans-italic */}
              <li><span className="font-bold text-blue-600">&diams;</span> Delivering innovative, business-centric tech solutions — from design to deployment.</li>
              <li><span className="font-bold text-blue-600">&diams;</span> Providing expert training and consultancy to enhance your team’s technological capabilities.</li>
              <li><span className="font-bold text-blue-600">&diams;</span> Trusted by businesses seeking agility, precision, and long-term value in digital transformation.</li>
            </ul>
            <p className="text-lg leading-relaxed text-gray-700 font-open-sans-italic"> {/* Added font-open-sans-italic */}
              With Enigmalogix, you get a one-stop technology partner ready to meet your evolving digital needs.
            </p>
            <button
              onClick={() => setCurrentPage('contact')}
              className="mt-8 bg-blue-600 text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-blue-700 transition-colors shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
            >
              Connect With Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );



  // Contact Section component - REVISED FOR FORMSPREE
  const ContactSection = () => {
    // For Formspree, direct form submission handles the email sending.
    // React state for 'isSending' or 'messageStatus' is less critical as Formspree handles feedback
    // (e.g., redirecting to a "Thank You" page or showing a success message on their site).
    // However, you can add client-side validation here if needed before submission.

    return (
      <section className="py-20 bg-gray-50 rounded-lg m-2 shadow-lg">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl md:text-5xl font-bold text-center text-blue-950 mb-16">
            Get in Touch
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Information */}
            <div className="bg-white p-8 rounded-xl shadow-md border border-gray-200">
              <h3 className="text-3xl font-bold text-blue-950 mb-6">Contact Information</h3>
              <div className="space-y-6 text-gray-700 text-lg">
                <p className="flex items-center">
                  <MailIcon className="w-6 h-6 mr-3 text-blue-600" />
                  Email: <a href="mailto:info@enigmalogix.com" className="ml-2 text-blue-600 hover:underline">info@enigmalogix.com</a>
                </p>
                <p className="flex items-center">
                  <PhoneIcon className="w-6 h-6 mr-3 text-blue-600" />
                  Phone: <a href="tel:+7895079139" className="ml-2 text-blue-600 hover:underline">+91-7895079139</a>
                </p>
                <p className="flex items-start">
                  <MapPinIcon className="w-6 h-6 mr-3 text-blue-600 flex-shrink-0 mt-1" />
                  Address:
                  <span className="ml-2">
                    OC-434 Gaur City Center<br />
                    Sector 4, Greater Noida (W)<br />
                    Uttar Pradesh, 201009, India
                  </span>
                </p>
              </div>
              {/* Social Media Links */}
              <div className="mt-10">
                <h3 className="text-2xl font-bold text-blue-950 mb-4">Follow Us</h3>
                <div className="flex space-x-4">
                  {/* Changed styling for LinkedIn icon to match the service icons */}
                  <a
                    href="https://www.linkedin.com/company/enigmalogix"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block p-3 bg-blue-100 rounded-full text-blue-600 hover:bg-blue-200 transition-colors transform hover:scale-110"
                  >
                    <LinkedinIcon className="w-8 h-8" />
                  </a>
                </div>
              </div>
            </div>

            {/* Contact Form - Now using Formspree */}
            <div className="bg-white p-8 rounded-xl shadow-md border border-gray-200">
              <h3 className="text-3xl font-bold text-blue-950 mb-6">Send Us a Message</h3>
              {/* IMPORTANT: Replace "YOUR_FORMSPREE_ENDPOINT" with your actual Formspree form URL */}
              {/* Formspree uses standard HTML form submission. No need for onSubmit handler in React if it's a simple post. */}
              <form action="https://formspree.io/f/xyzjlovj" method="POST" className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-gray-700 text-sm font-bold mb-2">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name" // Standard name attribute for form fields
                    className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                    placeholder="Your Name"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-gray-700 text-sm font-bold mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="_replyto" // Formspree uses _replyto to set the reply-to email
                    className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                    placeholder="your.email@example.com"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="subject" className="block text-gray-700 text-sm font-bold mb-2">
                    Subject
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="_subject" // Formspree uses _subject for the email subject line
                    className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                    placeholder="Subject of your inquiry"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="message" className="block text-gray-700 text-sm font-bold mb-2">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message" // Standard name for the message content
                    rows="6"
                    className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                    placeholder="Your message..."
                    required
                  ></textarea>
                </div>
                {/* Optional: Add a hidden input to redirect to a specific URL after submission */}
                {/* <input type="hidden" name="_next" value="https://yourwebsite.com/thank-you.html" /> */}
                <div className="flex justify-end">
                  <button
                    type="submit"
                    className="bg-blue-600 text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-blue-700 transition-colors shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                  >
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    );
  };

  // New Global Presence Section component
  const GlobalPresenceSection = () => (
    <section className="py-20 bg-gray-50 rounded-lg m-2 shadow-lg">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-blue-950 mb-16 font-circular-std-bold">
          Global Presence
        </h2>
        {/* Changed grid layout to handle three columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {/* Location 1: New York */}
          <div className="bg-white p-8 rounded-xl shadow-md border border-gray-200">
            <img
              src="https://static5.depositphotos.com/1030296/395/i/450/depositphotos_3958211-stock-photo-new-york-cityscape-tourism-concept.jpg" // Placeholder image for New York
              alt="New York City Skyline"
              className="rounded-lg mb-6 w-full h-48 object-cover"
            />
            <h3 className="text-2xl font-semibold text-blue-800 mb-2">USA</h3>
            <p className="text-gray-700 mb-2"></p>
            <p className="text-gray-700 mb-4">
              26319 Hunter Lane, Katy, Texas, 77494 USA
            </p>
            <p className="flex items-center text-gray-700 mb-2">
              <PhoneIcon className="w-5 h-5 mr-2 text-blue-600" />
              Phone: +1 832-819-1970
            </p>
            <p className="flex items-center text-gray-700">
              <MailIcon className="w-5 h-5 mr-2 text-blue-600" />
              Email: info@enigmalogix.com
            </p>
          </div>

          {/* Location 2: New Jersey */}
          <div className="bg-white p-8 rounded-xl shadow-md border border-gray-200">
            <img
              src="https://images.pexels.com/photos/1868676/pexels-photo-1868676.jpeg?cs=srgb&dl=pexels-sahil-1868676.jpg&fm=jpg" // Placeholder image for New Jersey
              alt="Canada"
              className="rounded-lg mb-6 w-full h-48 object-cover"
            />
            <h3 className="text-2xl font-semibold text-blue-800 mb-2">Canada</h3>
            <p className="text-gray-700 mb-2"></p>
            <p className="text-gray-700 mb-4">
              448 Shawnee Square SW, Calgary, Alberta, T2Y0W4
            </p>
            <p className="flex items-center text-gray-700 mb-2">
              <PhoneIcon className="w-5 h-5 mr-2 text-blue-600" />
              Phone: +1 832-819-1970
            </p>
            <p className="flex items-center text-gray-700">
              <MailIcon className="w-5 h-5 mr-2 text-blue-600" />
              Email: info@enigmalogix.com
            </p>
          </div>

          {/* Location 3: Australia */}
          <div className="bg-white p-8 rounded-xl shadow-md border border-gray-200">
            <img
              src="https://i.natgeofe.com/k/b76526f3-bb84-489d-b229-56bcc08aa915/australia-sydney-opera-house.jpg?wp=1&w=1084.125&h=611.625" // Placeholder image for Australia
              alt="Australia Cityscape"
              className="rounded-lg mb-6 w-full h-48 object-cover"
            />
            <h3 className="text-2xl font-semibold text-blue-800 mb-2">Australia</h3>
            <p className="text-gray-700 mb-2"></p>
            <p className="text-gray-700 mb-4">
             7 Zac street,Tarneit 3029
              Melbourn, Victoria,
              Australia
            </p>
            <p className="flex items-center text-gray-700 mb-2">
              <PhoneIcon className="w-5 h-5 mr-2 text-blue-600" />
              Phone: +61 426-273-812
            </p>
            <p className="flex items-center text-gray-700">
              <MailIcon className="w-5 h-5 mr-2 text-blue-600" />
              Email: info@enigmalogix.com
            </p>
          </div>
        </div>
      </div>
    </section>
  );

  // Footer component
  const Footer = () => (
    <footer className="bg-blue-950 text-gray-300 py-12 rounded-lg m-2 shadow-inner">
      <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-4 gap-8">
        {/* Company Info */}
        <div>
          <h3 className="text-xl font-bold text-white mb-4">ENIGMALOGIX</h3>
          <p className="text-sm">Your trusted partner for innovative technology solutions. We build the future, today.</p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-xl font-bold text-white mb-4">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            {/* Quick links also swapped */}
            <li><button onClick={() => setCurrentPage('about')} className="hover:text-white transition-colors">About Us</button></li>
            <li><button onClick={() => setCurrentPage('services')} className="hover:text-white transition-colors">Services</button></li>
            <li><button onClick={() => setCurrentPage('contact')} className="hover:text-white transition-colors">Contact Us</button></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-xl font-bold text-white mb-4">Contact Info</h3>
          <ul className="space-y-2 text-sm">
            <li>Email: <a href="mailto:info@enigmalogix.com" className="hover:text-white transition-colors">info@enigmalogix.com</a></li>
            <li>Phone: <a href="tel:+91XXXXXXXXXX" className="hover:text-white transition-colors">+91-7895079139</a></li>
            <li>Address: OC- 434 Gaur City Center, Sector 4, Greater Noida (W), Uttar Pradesh, 201009, India</li>
          </ul>
        </div>

        {/* Follow Us */}
        <div className="text-center"> {/* Added text-center here to center the whole block */}
          <h3 className="text-xl font-bold text-white mb-4">Follow Us</h3>
          {/* Changed the outer div to use flex justify-center and wrapped the LinkedinIcon with <a> */}
          <div className="flex justify-center">
            {/* Added your LinkedIn URL here */}
            <a href="https://www.linkedin.com/company/enigmalogix" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
              <LinkedinIcon className="w-6 h-6" />
            </a>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="text-center text-gray-500 text-sm mt-10 border-t border-gray-700 pt-6">
        <p>&copy; <span id="currentYear"></span> ENIGMALOGIX. All rights reserved.</p>
      </div>
    </footer>
  );

  // --- Render based on currentPage state ---
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col font-inter">
      {/* Import Poppins and Circular Std fonts */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');
          @import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital@1&display=swap');
          /* Attempting to import Circular Std from a common CDN. If this doesn't work,
              Circular Std might need to be licensed or manually included in your project. */
          @import url('https://fonts.cdnfonts.com/css/circular-std');

          .font-poppins {
            font-family: 'Poppins', sans-serif;
          }
          .font-circular-std-bold {
            font-family: 'Circular Std Bold', sans-serif;
            font-weight: 700; /* Ensure it's bold */
          }
          .font-open-sans-italic {
            font-family: 'Open Sans', sans-serif;
            font-style: italic;
          }

          @keyframes fade-in {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-in {
            animation: fade-in 0.3s ease-out forwards;
          }
        `}
      </style>

      {/* Render Header */}
      <Header currentPage={currentPage} scrollPosition={scrollPosition} isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />

      {/* Main content area */}
      <main className="flex-grow">
        {currentPage === 'home' && (
          <>
            <HeroSection />
            {/* AboutSection now before ServicesSection on the home page */}
            <AboutSection />
            <ServicesSection />
            {/* Removed the CallToActionSection from the home page rendering */}
          </>
        )}
        {currentPage === 'about' && (
          <AboutSection />
        )}
        {currentPage === 'services' && (
          <ServicesSection />
        )}
        {currentPage === 'contact' && (
          <>
            <ContactSection />
            <GlobalPresenceSection /> {/* Render the new global presence section */}
          </>
        )}
      </main>

      {/* Render Footer */}
      <Footer />
    </div>
  );
}
